module.exports = __webpack_public_path__ + "static/media/nut.aebe6738.jpg";